var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5C8.61929 2.5 7.5 3.61929 7.5 5V5.5H3C2.72386 5.5 2.5 5.72386 2.5 6C2.5 6.27614 2.72386 6.5 3 6.5H4.5V19C4.5 20.3807 5.61929 21.5 7 21.5H17C18.3807 21.5 19.5 20.3807 19.5 19V6.5H21C21.2761 6.5 21.5 6.27614 21.5 6C21.5 5.72386 21.2761 5.5 21 5.5H16.5V5C16.5 3.61929 15.3807 2.5 14 2.5H10ZM15.5 5.5V5C15.5 4.17157 14.8284 3.5 14 3.5H10C9.17157 3.5 8.5 4.17157 8.5 5V5.5H15.5ZM5.5 6.5V19C5.5 19.8284 6.17157 20.5 7 20.5H17C17.8284 20.5 18.5 19.8284 18.5 19V6.5H5.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.5C10.2761 10.5 10.5 10.7239 10.5 11V16C10.5 16.2761 10.2761 16.5 10 16.5C9.72386 16.5 9.5 16.2761 9.5 16V11C9.5 10.7239 9.72386 10.5 10 10.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10.5C14.2761 10.5 14.5 10.7239 14.5 11V16C14.5 16.2761 14.2761 16.5 14 16.5C13.7239 16.5 13.5 16.2761 13.5 16V11C13.5 10.7239 13.7239 10.5 14 10.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.72705dcddd8b79538c60c940b063110b.svg";
export { ForwardRef as ReactComponent };